export default function SignalsIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-activity'
      data-lov-id='src/components/Sidebar.tsx:112:18'
      data-lov-name='Activity'
      data-component-path='src/components/Sidebar.tsx'
      data-component-line='112'
      data-component-file='Sidebar.tsx'
      data-component-name='Activity'
      data-component-content='%7B%7D'
    >
      <path d='M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2' />
    </svg>
  );
}
